import { SelectOption } from "@metsooutotec/modes-react-components";

export type SelectValue = SelectOption["value"] | SelectOption["value"][];
export const convertValueToOption = (value: SelectValue, options: SelectOption[]): SelectOption => {
    // Handle case where value is a single string
    return options.find(option => option.value === value) as SelectOption;
};
